export default function indianNumberFormatter(num: any) {
    const numberFormat = num?.replace(/,/g, "");
    if (typeof Number(numberFormat) !== "number" || isNaN(numberFormat)) return null;

    return numberFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}